import { memo } from 'react';
import StatefulField from './StatefulField';

const OldPasswordField = ({ oldPassword, setOldPassword, isEmpty }) => {
	const hint = isEmpty && 'Bitte geben Sie Ihr Passwort, um fortzufahren!';

	return (
		<StatefulField
			id='old-password'
			type='password'
			isRequired={true}
			autoComplete='current-password'
			label='Altes Passwort'
			placeholder='Bitte geben Sie Ihr altes Passwort ein.'
			value={oldPassword}
			updateValue={setOldPassword}
			validator={!isEmpty}
			hint={hint}
		/>
	);
};

export default memo(OldPasswordField);
